export default __webpack_public_path__ + "check-small.0139c29003363e94.svg";